var _circle, _circle2, _circle3, _circle4, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPalette = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "lucide lucide-palette-icon lucide-palette",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 13.5,
  cy: 6.5,
  r: 0.5,
  fill: "currentColor"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 17.5,
  cy: 10.5,
  r: 0.5,
  fill: "currentColor"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 8.5,
  cy: 7.5,
  r: 0.5,
  fill: "currentColor"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 6.5,
  cy: 12.5,
  r: 0.5,
  fill: "currentColor"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 22a1 1 0 0 0 1-1 8 8 0 0 1 8-8 1 1 0 0 0 0-2A10 10 0 1 0 10 21a1 1 0 0 0 1 1Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPalette);
export { ForwardRef as ReactComponent };